import { callGetApiToServer } from '../callApi';

export async function getAllCard(
  authtoken,
  skipNumber,
  limitNumber,
  city,
  cardType,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    }
  
    let queryParams = [];
    if (city) {
      queryParams.push(`city=${encodeURIComponent(city)}`);
    }
    if (cardType && cardType !== "all") {
      queryParams.push(`card_type=${encodeURIComponent(cardType)}`);
    }

    let endUrl = `v1/auth/list-card/${skipNumber}/${limitNumber}`;
    if (queryParams.length > 0) {
      endUrl = `${endUrl}?${queryParams.join("&")}`;
    }
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callGetApiToServer(header, "GET", endUrl);
      
    return responseData;
  }catch(err) {
    throw err;
  }
}
